export const TOAST_MESSAGES = {
  // Shared/Generic
  UNAUTHORIZED: "Session expired or unauthorized. Please log in again.",
  GENERAL_ERROR: "Something went wrong",

  // Model messages
  MODEL: {
    FETCH_ERROR: "Failed to fetch models",
    STATUS_UPDATE_SUCCESS: "Model status changed",
    STATUS_UPDATE_ERROR: "Failed to change status",
    DOWNLOAD_SUCCESS: "Download triggered successfully",
    DOWNLOAD_ERROR: "Failed to trigger download",
    FORM_SUBMIT_ERROR: "Something went wrong",
    NAME_REQUIRED: "Model name is required",
    ADD_SUCCESS: "Model added successfully",
    UPDATE_SUCCESS: "Model updated successfully",
    ADD_ERROR: "Failed to add model",
    UPDATE_ERROR: "Failed to update model",
  },

  WEBSITE_UPLOAD: {
    SUCCESS: "Website uploaded successfully!",
    ERROR: "Website upload failed.",
    EMPTY: "Please enter a valid website URL.",
  },

  UPLOAD: {
    SUCCESS: "Upload completed successfully.",
    FAILED: "Upload failed. Please try again.",
  },

  NOTIFICATION: {
    FETCH_ERROR: "Failed to fetch notifications.",
    MARK_READ_SUCCESS: "Notification marked as read.",
    MARK_READ_ERROR: "Failed to mark notification as read.",
    NO_NEW: "No new notifications.",
  },

  UPLOADED_DOCS: {
    APPROVE_SUCCESS: "Document approved successfully.",
    REJECT_SUCCESS: "Document rejected successfully.",
    ACTION_FAILED: "Failed to process your action.",
    FETCH_FAILED: "Failed to load uploaded documents.",
  },

  DOCUMENT_HISTORY: {
    FETCH_FAILED: "Failed to load document history. Please try again later.",
    FETCH_SUCCESS: "Document history loaded successfully.",
  },

  YOUTUBE_HISTORY: {
    FETCH_FAILED: "Failed to load YouTube history. Please try again later.",
    FETCH_SUCCESS: "YouTube history loaded successfully.",
  },

  TEXT_UPLOAD: {
    SUCCESS: "Text uploaded successfully.",
    ERROR: "Failed to upload text.",
    EMPTY: "Please enter some text.",
  },

  URL_HISTORY: {
    FETCH_FAILED: "Failed to load URL history. Please try again later.",
    FETCH_SUCCESS: "URL history loaded successfully.",
  },

  QA_UPLOAD: {
    SUCCESS: "Q&A added successfully.",
    ERROR: "Failed to add Q&A.",
    EMPTY: "Please enter both question and answer.",
  },

  VERSION: {
    CREATE_SUCCESS: "Version created successfully.",
    CREATE_ERROR: "Failed to create version.",
    UPDATE_SUCCESS: "Version updated successfully.",
    UPDATE_ERROR: "Failed to update version.",
    STATUS_CHANGE_SUCCESS: "Version status changed successfully",
    STATUS_CHANGE_ERROR: "Failed to change version status",
  },

  // Module messages
  MODULE: {
    FETCH_ERROR: "Failed to fetch modules",
    CREATE_SUCCESS: "Module added successfully",
    CREATE_ERROR: "Failed to add module",
    UPDATE_SUCCESS: "Module updated successfully",
    UPDATE_ERROR: "Failed to update module",
    DELETE_SUCCESS: "Module deleted successfully",
    DELETE_ERROR: "Failed to delete module",
    STATUS_CHANGE_SUCCESS: "Module status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
    UNAUTHORIZED: "Session expired or unauthorized. Please log in again.",
    GENERAL_ERROR: "Something went wrong",
  },

  PRODUCT: {
    FETCH_ERROR: "Failed to fetch products",
    CREATE_SUCCESS: "Product added successfully",
    CREATE_ERROR: "Failed to add product",
    UPDATE_SUCCESS: "Product updated successfully",
    UPDATE_ERROR: "Failed to update product",
    DELETE_SUCCESS: "Product deleted successfully",
    DELETE_ERROR: "Failed to delete product",
    STATUS_CHANGE_SUCCESS: "Product status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
  },

  ENTERPRISE: {
    FETCH_ERROR: "Failed to fetch enterprises",
    CREATE_SUCCESS: "Enterprise added successfully",
    CREATE_ERROR: "Failed to add enterprise",
    UPDATE_SUCCESS: "Enterprise updated successfully",
    UPDATE_ERROR: "Failed to update enterprise",
    DELETE_SUCCESS: "Enterprise deleted successfully",
    DELETE_ERROR: "Failed to delete enterprise",
    STATUS_CHANGE_SUCCESS: "Enterprise status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
  },

  USER: {
    FETCH_ERROR: "Failed to fetch users",
    CREATE_SUCCESS: "User added successfully",
    CREATE_ERROR: "Failed to add user",
    UPDATE_SUCCESS: "User updated successfully",
    UPDATE_ERROR: "Failed to update user",
    STATUS_CHANGE_SUCCESS: "User status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
    PASSWORD_MISMATCH: "Passwords do not match",
  },

  AUTH: {
    LOGIN_SUCCESS: "Login successful!",
    LOGIN_FAILED: "Login failed",
    NO_ROLE: "Role not assigned. Contact admin.",

    RESET_CODE_SENT: "Password reset email sent successfully!",
    RESET_EMAIL_FAILED: "Failed to send reset email. Please try again.",

    PASSWORD_TOO_SHORT: "Password must be at least 6 characters.",
    PASSWORD_NEEDS_UPPER:
      "Password must include at least one uppercase letter.",
    PASSWORD_NEEDS_SPECIAL: "Include at least one special character.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    SESSION_EXPIRED: "Session expired. Please restart the process.",
    PASSWORD_RESET_SUCCESS: "Your password has been reset successfully!",
    PASSWORD_RESET_FAILED: "Password reset failed. Try again.",

    EMAIL_VERIFIED: "OTP verified successfully!",
    EMAIL_VERIFICATION_FAILED: "Invalid or expired OTP.",
    ENTER_FULL_OTP: "Please enter the full 6-digit code.",
  },

  ROLE: {
    FETCH_ERROR: "Failed to fetch roles",
    CREATE_SUCCESS: "Role added successfully",
    CREATE_ERROR: "Failed to add role",
    UPDATE_SUCCESS: "Role updated successfully",
    UPDATE_ERROR: "Failed to update role",
    DELETE_SUCCESS: "Role deleted successfully",
    DELETE_ERROR: "Failed to delete role",
    STATUS_CHANGE_SUCCESS: "Role status changed",
    STATUS_CHANGE_ERROR: "Failed to change status",
  },

  ENTERPRISE_SETTINGS: {
    ORG_CREATE_SUCCESS: "Organization settings created successfully.",
    ORG_UPDATE_SUCCESS: "Organization settings updated successfully.",
    DISC_CREATE_SUCCESS: "Disclaimer created successfully.",
    DISC_UPDATE_SUCCESS: "Disclaimer updated successfully.",
    SAVE_ERROR: "Failed to save enterprise settings.",

    SUB_CREATE_SUCCESS: "Subscription created successfully.",
    SUB_UPDATE_SUCCESS: "Subscription updated successfully.",
    FETCH_SUBSCRIPTION_ERROR: "Failed to fetch subscription data.",
    FETCH_ORG_SETTINGS_ERROR: "Failed to fetch organization settings.",
    FETCH_DISCLAIMER_ERROR: "Failed to fetch disclaimer settings.",

    SAVE_SUCCESS: "Settings saved successfully.",
  },

  SUBSCRIPTION: {
    FETCH_ERROR: "Failed to fetch subscriptions.",
    CREATE_ERROR: "Failed to create subscription.",
    UPDATE_ERROR: "Failed to update subscription.",
    STATUS_CHANGE_ERROR: "Failed to change status.",
    STATUS_CHANGE_SUCCESS: "Subscription status changed",
    CREATE_SUCCESS: "Subscription created successfully.",
    UPDATE_SUCCESS: "Subscription updated successfully.",
  },

  PROFILE: {
    IMAGE_UPLOAD_SUCCESS: "Profile image updated!",
    IMAGE_UPLOAD_FAILED: "Image upload failed",
    IMAGE_TOO_LARGE: "Image size must be less than 1MB",
    SAVE_SUCCESS: "Changes saved successfully",
    SAVE_FAILED: "Failed to save changes",
    FETCH_FAILED: "Failed to load user profile",
  },
};
